<template>
    <div>
        <quote-factory :productId="productId" />
    </div>
</template>

<script lang="ts" setup>
import QuoteFactory from '@/components/Quote/Factory.vue'
import { computed } from 'vue'

const productId = computed(() => (window as any)?.productId)
</script>
